<template>
    <div class="page">
      <my-header :breadcrumb="breadcrumb"></my-header>
      <div class="page-content">
        <el-form :model="form">

          <el-form-item label="文章分类" :label-width="formLabelWidth">
            <el-cascader
              v-model="form.arrCate"
              :options="categoryOptions"
              @change="handleChange"></el-cascader>
          </el-form-item>

          <el-form-item label="文章名称" :label-width="formLabelWidth">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="子标题" :label-width="formLabelWidth">
            <el-input v-model="form.sub_title"></el-input>
          </el-form-item>
<!--          <el-form-item label="城市区域" :label-width="formLabelWidth">
            <el-cascader
                ref="myCascader"
                v-model="form.arrRegion"
                :options="cityOptions" :props="{ checkStrictly: true }"
                @change="handleCityChange"></el-cascader>
          </el-form-item>-->
          <el-form-item label="文章封面" :label-width="formLabelWidth">
            <el-upload
                class="avatar-uploader"
                :action="apiUrl+'/v1/upload/upload'"
                :show-file-list="false"
                :on-remove="handleRemove" :headers="headers"
                :on-success="uploadSuccess">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i class="el-icon-plus avatar-uploader-icon" v-else ></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="摘要" :label-width="formLabelWidth">
            <el-input type="textarea"
                      :rows="3"  v-model="form.summary"></el-input>
          </el-form-item>

          <el-form-item label="文章内容" :label-width="formLabelWidth">
            <ckeditor :editor="editor" v-model="form.content" :config="editorConfig" @ready="onReady"></ckeditor>
          </el-form-item>
          <el-form-item label="文章标签" :label-width="formLabelWidth">
            <el-input v-model="form.tag"></el-input>
          </el-form-item>
<!--          <el-form-item label="是否推送百度" :label-width="formLabelWidth">
            <el-checkbox v-model="form.tuibaidu">推送百度收录</el-checkbox>
          </el-form-item>-->
          <el-form-item label="投放前" :label-width="formLabelWidth">
            <el-upload
                class="avatar-uploader"
                :action="apiUrl+'/v1/upload/upload'"
                :show-file-list="false"
                :on-remove="handleRemove" :headers="headers"
                :on-success="uploadSuccessBefore">
              <img v-if="form.before_img" :src="form.before_img" class="avatar">
              <i class="el-icon-plus avatar-uploader-icon" v-else ></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="投放后" :label-width="formLabelWidth">
            <el-upload
                class="avatar-uploader"
                :action="apiUrl+'/v1/upload/upload'"
                :show-file-list="false"
                :on-remove="handleRemove" :headers="headers"
                :on-success="uploadSuccessAfter">
              <img v-if="form.after_img" :src="form.after_img" class="avatar">
              <i class="el-icon-plus avatar-uploader-icon" v-else ></i>
            </el-upload>
          </el-form-item>
          <el-form-item  :label-width="formLabelWidth">
            <el-button type="primary" @click="onSubmit">立即保存</el-button>
            <el-button @click="clickBackList">返回列表</el-button>
          </el-form-item>
        </el-form>

      </div>
    </div>
</template>

<script>
  import MyHeader from '../header'
  import Cookies from 'js-cookie'
  import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
  import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/zh-cn';
  import MyUploadAdapter from "../../../MyUploadAdapter.js";
  export default {
    name: 'edit',
    components: {
      MyHeader
    },
    data(){
      return {
        form:{
          tuibaidu:false,
          before_img:'',
          after_img:''
        },
        formLabelWidth:'120px',
        categoryOptions:[],
        editor:DecoupledEditor,
        editorData: '',
        editorConfig: {
          // Run the editor with the German UI.
          language: 'zh-cn',
        },
        breadcrumb:[
          {name:'文章列表'},{name:'编辑文章'}
        ],
        cityOptions:[],
        headers:{},
        imgList: [],
        dialogImageUrl: '',
        dialogVisible: false,
        imageUrl:''
      }
    },
    created () {

      this.headers.Authorization = 'Bearer ' + Cookies.get('access_token');
      this.$http.get('/v1/acategory/children',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
        this.categoryOptions = data.result;
      })
      this.$http.get('/v1/region/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
        this.cityOptions = data.result;
      })
      this.form.article_id = this.$route.query.id;
      if (this.form.article_id != undefined){
        this.$http.get('/v1/article/view?id='+this.form.article_id).then(({data})=>{
          this.form = data.result;
          var arr = data.result.all_cateid.split(',');
          this.form.arrCate = arr;
          this.imageUrl = this.form.cover_img;
        })
      }

    },
    methods:{
      onReady( editor )  {
        // Insert the toolbar before the editable area.
        editor.ui.getEditableElement().parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
        // 自定义上传图片插件
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
          return new MyUploadAdapter(loader);
        };
      },
      clickConfirm(){

      },
      handleChange(val){
        //console.log(val)
        var objName = this.getCascaderObj(val,this.categoryOptions)
        //console.log(objName)
        this.form.cate_name = objName[0].cate_name;
      },
      handleCityChange(val){
        this.form.region_name = this.$refs.myCascader.getCheckedNodes()[0].pathLabels;
      },
      getCascaderObj(val,opt) {
        return val.map(function (value, index, array) {
          for (var itm of opt) {
            // console.log(opt)
            if (itm.cate_id == value) { opt = itm.children; return itm; }
          }
          return null;
        });
      },
      onSubmit(){
        this.form.cover_img = this.imageUrl;
        this.$http.post('/v1/article/save',this.form).then(({data})=>{
          if (data.errcode == 0){
            this.$message.success(data.msg)
          }else{
            this.$message.error(data.msg)
          }
        })
      },
      clickBackList(){
        this.$router.push('/admin/article/list')
      },
      uploadSuccess(res, file, fileList) {
        if (res.errcode == 0) {
          this.imageUrl = res.imgUrl;
        }
      },
      uploadSuccessBefore(res, file, fileList) {
        if (res.errcode == 0) {
          this.form.before_img = res.imgUrl;
        }
      },
      uploadSuccessAfter(res, file, fileList) {
        if (res.errcode == 0) {
          this.form.after_img = res.imgUrl;
        }
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
        var _this = this;
        this.$http.post('/v1/article/delete-img',{file_id:file.file_id}).then(({data})=>{
          if (data.errcode == 0){
            _this.imgList.splice(_this.imgList.indexOf(file.file_id),1)
            this.$message.success(data.msg)
          }else{
            this.$message.error(data.msg)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .ck.ck-editor__editable_inline {
    border: 1px solid var(--ck-color-base-border);
    min-height: 400px;
  }
  .page-content >>> .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .page-content >>> .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .page-content >>> .avatar-uploader .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .page-content >>> .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
